import React, {Component} from 'react';
import {Card, Empty, Table} from "antd";

class LinkList extends Component {

    state = {
        data: []
    }

    componentDidMount() {
        const {match, handleSearch, filters} = this.props;
        // console.log(filters)
        if (match.params && match.params.asset) {
            handleSearch([[match.params.asset]], {type: "ObjectID", field: 'asset'});
        }
        // console.log(this.props.match.params.asset);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        // console.log(nextProps.data);
        if (nextProps && nextProps.data /*&& JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)*/) {
            this.setState({
                data: nextProps.data
            })
        }
    }

    render() {
        // console.log(this.props.columns, this.state.data)
        return (
            <div>
                <h2>Asset Tagging List</h2>
                <Card>
                    {this.state.data ?
                        <Table dataSource={this.state.data} columns={this.props.columns} loading={this.props.loading}/>
                        : <Empty/>
                    }
                </Card>
            </div>
        );
    }
}

export default LinkList;
